module.exports = __webpack_public_path__ + "media/referrals/bg1-15a6e0c4.png";